<template>
  <v-app id="inspire" ref="app">
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-app-bar-nav-icon
        color="primary"
        class="mobile-burger hidden-md-and-up"
        @click.stop="
          drawer = !drawer;
          showFilters = false;
        "
      />
      <div class="logo_container" style="margin: 2rem auto 3rem">
        <img @click="refreshToken" class="logo" src="/img/rapihogar.png" />
      </div>
      <v-list dense>
        <template v-for="item in items">
          <v-row v-if="item.heading" :key="item.heading" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
            <v-col cols="6" class="text-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item v-for="(child, i) in item.children" :key="i" link>
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
            v-else-if="item.route == 'sign-out'"
            :key="item.text"
            @click="signOut"
            link
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <router-link v-else :key="item.text" :to="{ name: item.route }">
            <v-list-item :key="item.text" link @click="resetFilters()">
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="white">
      <v-app-bar-nav-icon
        color="primary"
        class="mobile-burger"
        @click.stop="
          drawer = !drawer;
          showFilters = false;
        "
      />
      <v-row align="center" justify="space-between" style="margin-right: 0">
        <v-toolbar-title
          style="color: #1b203f; font-weight: 600"
          class="ml-0 pl-4"
        >
          <span>{{ $store.state.app_title }}</span>
        </v-toolbar-title>
        <v-spacer />

        <!-- MENU FILTROS -->
        <v-menu
          v-model="showFilters"
          :close-on-content-click="false"
          offset-y
          :position-y="57"
          absolute
          bottom
          style="width: 100vw"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-show="$router.currentRoute.name == 'notification-list'"
              style="margin-right: 16px"
              :color="filterIconColor"
              v-bind="attrs"
              v-on="on"
            >
              filter_list
            </v-icon>
          </template>

          <v-card flat style="width: 100vw">
            <v-container>
              <v-row>
                <!-- SELECTOR TIPO DE NOTIFICACIÓN -->
                <v-col cols="12">
                  <v-select
                    label="Tipo"
                    outlined
                    v-model="selectedNotificationType"
                    :items="$store.state.notification_types"
                    item-text="label"
                    item-value="name"
                    clearable
                    hide-details
                    flat
                    value="1"
                  />
                </v-col>
                <!-- FIN SELECTOR TIPO DE NOTIFICACIÓN -->

                <!-- SELECTOR ESTADO DE NOTIFICACIÓN -->
                <v-col cols="12">
                  <v-select
                    label="Estado"
                    outlined
                    v-model="selectedNotificationStatus"
                    :items="notificationStatuses"
                    item-text="text"
                    item-value="value"
                    clearable
                    hide-details
                    flat
                    value="1"
                  />
                </v-col>
                <!-- FIN SELECTOR ESTADO DE NOTIFICACIÓN -->

                <!-- SELECTOR COLUMNAS VISIBLES -->
                <!-- <v-col
                  class="hidden-sm-and-down"
                  cols="12"
                  v-show="
                    $router.currentRoute.name == 'request-list' ||
                    $router.currentRoute.name == 'visit-list'
                  "
                >
                  <v-select
                    label="Seleccionar columnas"
                    outlined
                    multiple
                    v-model="currentHeaders"
                    :items="computedHeaders"
                    @change="saveHeaders"
                    item-text="text"
                    item-value="value"
                    hide-details
                  />
                </v-col> -->
                <!-- FIN SELECTOR COLUMNAS VISIBLES -->
              </v-row>
            </v-container>
          </v-card>
        </v-menu>

        <!-- ICONO DE NOTIFICACIONES -->
        <v-icon
          v-show="
            $router.currentRoute.name == 'request-list' ||
            $router.currentRoute.name == 'visit-list'
          "
          color="primary"
          @click="$router.push('notification-list')"
        >
          notifications
        </v-icon>

        <div
          class="unread-notifications"
          v-show="
            $store.state.unread_notifications > 0 &&
            ($router.currentRoute.name == 'request-list' ||
              $router.currentRoute.name == 'visit-list')
          "
          @click="$router.push('notification-list')"
        >
          {{ $store.state.unread_notifications }}
        </div>
        <!-- FIN ICONO DE NOTIFICACIONES -->

        <!-- ICONO HOME -->
        <v-icon
          v-show="
            $router.currentRoute.name == 'notification-list' ||
            $router.currentRoute.name == 'notification'
          "
          color="primary"
          @click="$router.push('visit-list')"
        >
          home
        </v-icon>
        <!-- FIN ICONO HOME -->
      </v-row>
    </v-app-bar>

    <v-alert
      v-if="showSnackbar"
      dense
      text
      type="warning"
      icon="mdi-wifi-strength-off-outline"
    >
      La conexión es inestable, es probable que la información de los pedidos no
      esté actualizada. Verificá tu conexión o esperá a que se restablezca
    </v-alert>

    <!-- CONTENIDO PRINCIPAL -->
    <div class="app-content">
      <router-view :key="$route.fullPath"></router-view>
    </div>

    <!-- FIN CONTENIDO PRINCIPAL -->

    <!-- ALERTA -->

    <v-snackbar v-model="$store.state.snackbar.show" :timeout="5000">
      {{ $store.state.snackbar.text }}
    </v-snackbar>

    <NotificationRequestDialog
      v-show="!this.hasPermissionGranted"
    ></NotificationRequestDialog>
    <!-- FIN ALERTA -->
  </v-app>
</template>

<script>
import firebase from "firebase/app";
import "firebase/messaging";
import "firebase/auth";
import moment from "moment";
import qs from "querystring";
import HeadersRequests from "../assets/js/headersRequests";
import HeadersVisits from "../assets/js/headersVisits";
import AppLogo from "../components/Mobs/AppLogo.vue";
import NotificationRequestDialog from "../components/NotificationRequestDialog";
import { eventBus } from "../main";

export default {
  name: "Main",

  components: {
    NotificationRequestDialog,
    AppLogo,
  },

  data: () => ({
    notificationStatuses: [
      {
        text: "Leída",
        value: true,
      },
      {
        text: "No leída",
        value: false,
      },
    ],
    showSnackbar: false,
    users: [],
    currentHeadersVersion: null,
    currentUserEmail: null,
    baseURL: null,
    drawer: null,
    selectedNotificationType: null,
    selectedNotificationStatus: null,
    showFilters: false,
    tokenIsRefreshing: false,

    items: [
      { icon: "search", text: "Pedidos", route: "request-list" },
      { icon: "calendar_today", text: "Eventos", route: "visit-list" },
      { icon: "local_atm", text: "Facturación", route: "bill-list" },
      {
        icon: "notifications",
        text: "Notificaciones",
        route: "notification-list",
      },
      { icon: "mdi-logout", text: "Cerrar sesión", route: "sign-out" },
    ],
  }),

  async mounted() {
    moment.locale("es");
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("online", () =>
      this.$store.commit("connected", true)
    );
    window.addEventListener("offline", () =>
      this.$store.commit("connected", false)
    );

    if (window.navigator.onLine) {
      this.$store.commit("connected", true);
    } else {
      this.$store.commit("connected", false);
    }

    const user = JSON.parse(localStorage.getItem("user") || "{}");
    this.currentUserEmail = user?.email;

    let storageBaseUrl = localStorage.getItem("baseURL");
    this.baseURL = storageBaseUrl ? JSON.parse(storageBaseUrl) : null;

    const userSettings = JSON.parse(
      localStorage.getItem("userSettings") || "{}"
    );

    this.$store.commit("set_user_settings", userSettings);

    if (!user || !this.baseURL || !userSettings) {
      this.signOut();
    }

    this.axios.interceptors.request.use(async (request) => {
      if (this.shouldTokenRefresh() && !this.tokenIsRefreshing) {
        request.headers.Authorization = await this.refreshToken();
      }
      return request;
    });

    this.cacheSettings();

    this.handleSWEvents();

    this.sendTokenFcm();

    this.$store.commit("set_loading_notifications", true);

    await this.getCachedNotifications();

    await this.getNotifications();

    this.updateHeadersIfNecessary();
  },

  created() {
    window.addEventListener("offline", this.handleOffline);
    window.addEventListener("online", this.handleOnline);

    eventBus.$on("badConnection", () => {
      this.showSnackbar = true;
    });
    eventBus.$on("goodConnection", () => {
      this.showSnackbar = false;
    });

    this.checkConnection();
  },

  beforeDestroy() {
    window.removeEventListener("offline", this.handleOffline);
    window.removeEventListener("online", this.handleOnline);

    eventBus.$off("badConnection");
    eventBus.$off("goodConnection");
  },

  computed: {
    mobsUser() {
      return this.$store.state.mobsUser;
    },

    hasPermissionGranted() {
      if (!("Notification" in window)) return false;
      return Notification.permission === "granted";
    },

    filterIconColor: function () {
      if (
        this.$store.state.notification_type ||
        (this.$store.state.notification_status !== null &&
          this.$store.state.notification_status !== undefined)
      )
        return "rapired";
      return "primary";
    },

    computedHeaders: function () {
      let _headers = this.$store.state.headers;

      if (!this.$store.state.app_display_username) {
        _headers = _headers.filter((item) => item.value !== "client");
        _headers = _headers.filter(
          (item) => item.value !== "request.client.full_name"
        );
      }

      _headers = _headers.filter(
        (item) =>
          item.value !== "request.display_id" &&
          item.value !== "request.status_request.id" &&
          item.value !== "request_id" &&
          item.value !== "visit_status"
      );

      return _headers;
    },
  },

  watch: {
    "$store.state.headers": function (val, old) {
      this.currentHeaders = [];
      val.forEach((item) => {
        if (item.show) this.currentHeaders.push(item.value);
      });
    },

    "$store.state.authorised": function (val, old) {
      if (val === false) {
        this.signOut();
      }
    },

    "$store.state.refresh_notifications": async function (val) {
      if (val === true) {
        await this.getNotifications();
        this.$store.commit("refresh_notifications", false);
      }
    },

    selectedNotificationType: function (val) {
      this.$store.commit("filter_notifications_by_type", val);
    },

    selectedNotificationStatus: function (val) {
      this.$store.commit("filter_notifications_by_status", val);
    },
  },

  methods: {
    checkConnection() {
      if (!navigator.onLine) {
        this.showSnackbar = true;
      } else {
        this.showSnackbar = false;
      }
    },
    handleOffline() {
      this.showSnackbar = true;
    },
    handleOnline() {
      this.showSnackbar = false;
    },

    handleConnectionSlow() {
      this.showSnackbar = true;
    },

    cacheSettings() {
      caches.open("data").then((cache) => {
        cache.put(
          "settings",
          new Response(
            JSON.stringify({
              email: this.currentUserEmail,
              baseURL: this.baseURL,
            })
          )
        );
      });
    },
    handleSWEvents() {
      const broadcast = new BroadcastChannel("webapp-tecnicos");

      broadcast.onmessage = (event) => {
        if (event.data && event.data.type === "REFRESH_DATA") {
          this.getCachedNotifications();
        }

        if (event.data && event.data.type === "REFRESH_CHAT") {
          let notification = event.data.body;
          this.$store.commit("set_message_chat", notification.data);
        }
      };
    },

    updateHeadersIfNecessary() {
      const currentHeadersVersion = this.currentHeadersVersion;
      const storedHeadersVersion = Number(
        localStorage.getItem("storedHeadersVersion")
      );

      if (currentHeadersVersion !== storedHeadersVersion) {
        localStorage.setItem(
          "storedHeadersVersion",
          JSON.stringify(currentHeadersVersion)
        );
        localStorage.setItem(
          "headersRequests",
          JSON.stringify(HeadersRequests)
        );
        localStorage.setItem("headersVisits", JSON.stringify(HeadersVisits));
        this.$store.commit("updateHeaders");
      }
    },

    shouldTokenRefresh() {
      const currentDate = new Date();
      const currentTime = currentDate.getTime();
      const createdTime = Number(localStorage.getItem("lastTokenRefreshTime"));
      const elapsedTime = currentTime - createdTime;
      const expiryTime = 3000000;
      if (elapsedTime > expiryTime) return true;
      return false;
    },

    async getCachedNotifications() {
      const request = new Request(this.currentUserEmail + "/notifications");
      const cache = await caches.open("data");
      const _response = await cache.match(request);
      let response;
      if (_response) response = await _response.json();
      if (response) this.loadNotifications(response);
    },

    async getNotifications() {
      try {
        const response = await this.axios.get("/notification/");
        this.loadNotifications(response);
        this.cacheNotifications(response);
      } catch (error) {
        console.error("Error al obtener las notificaciones", error.message);
      }
    },

    getNotificationTypes(notifications) {
      const types = [];
      notifications.forEach((notification) => {
        !types.find(
          (type) => type.name === notification.notification_type.name
        ) && types.push(notification.notification_type);
      });
      return types;
    },

    loadNotifications(response) {
      try {
        const notifications = response.data.notifications;
        const unread = response.data.unread;
        const types = this.getNotificationTypes(notifications);
        this.$store.commit("set_notification_types", types);
        this.$store.commit("set_user_notifications", notifications);
        this.$store.commit("set_unread_notifications", unread);
        this.$store.commit("set_loading_notifications", false);
      } catch (error) {
        console.error("Error al cargar las notificaciones", error.message);
      }
    },

    cacheNotifications(response) {
      caches
        .open("data")
        .then((cache) => {
          cache.put(
            this.currentUserEmail + "/notifications",
            new Response(JSON.stringify(response))
          );
        })
        .catch((error) => console.error(error));
    },

    async refreshToken() {
      this.tokenIsRefreshing = true;
      const user = JSON.parse(localStorage.getItem("user"));
      const refreshToken = user.stsTokenManager.refreshToken;
      const body = { grant_type: "refresh_token", refresh_token: refreshToken };
      const config = {
        headers: { "content-type": "application/x-www-form-urlencoded" },
      };
      const response = await this.axios.post(
        "https://securetoken.googleapis.com/v1/token?key=AIzaSyCoWoENixUVHz43t4BfL0DK6fiMrmBKDs4",
        qs.stringify(body),
        config
      );
      this.axios.defaults.headers.common.Authorization =
        "JWT " + response.data.access_token;
      user.stsTokenManager.accessToken = response.data.access_token;
      user.stsTokenManager.refreshToken = response.data.refresh_token;
      localStorage.setItem("user", JSON.stringify(user));
      let currentTime = new Date();
      currentTime = currentTime.getTime();
      localStorage.setItem("lastTokenRefreshTime", currentTime);
      this.tokenIsRefreshing = false;
      return "JWT " + response.data.access_token;
    },

    getDeviceType() {
      const ua = navigator.userAgent;
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "tablet";
      }
      if (
        /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          ua
        )
      ) {
        return "mobile";
      }
      return "desktop";
    },

    sendTokenFcm() {
      const device = this.getDeviceType();
      if (firebase.messaging.isSupported()) {
        firebase
          .messaging()
          .getToken()
          .then((currentToken) => {
            console.log({ device, currentToken });
            if (currentToken && device) {
              this.axios
                .post("/notification_fcm/subscribe/", {
                  device: device,
                  token_fcm: currentToken,
                })
                .catch((error) => {
                  console.log({ error });
                  throw new Error(`Error al suscribir el token: ${error}`);
                });
            } else {
              console.log(
                "No Instance ID token available. Request permission to generate one."
              );
            }
          })
          .catch((err) => {
            console.log("error", err);
          });
      }
    },

    handleScroll() {
      this.showFilters = false;
    },

    resetFilters() {
      this.selectedNotificationType = null;
      this.selectedNotificationStatus = null;

      this.$store.commit("filter_notifications_by_status", null);
      this.$store.commit("filter_notifications_by_type", null);
    },

    saveHeaders() {
      const newHeaders = [];

      this.$store.state.headers.forEach((item) => {
        const headerFound = this.currentHeaders.find(
          (itemB) => itemB === item.value
        );

        if (headerFound) {
          newHeaders.push({ ...item, show: true });
        } else {
          newHeaders.push({ ...item, show: false });
        }
      });

      this.$store.commit("set_headers", newHeaders);
    },

    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$store.commit("set_user_techReqs", []);
          this.$store.commit("setState");
          this.$store.commit("invoice/setState");
          localStorage.clear();
          this.$router.push({ name: "login" });
        })
        .catch((error) => console.error(error.message));
    },
  },
};
</script>

<style>
.unread-notifications {
  background-color: #c8272a;
  color: white;
  border-radius: 50%;
  height: 16px;
  width: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  right: 12px;
  top: 12px;
  position: absolute;
}
a {
  text-decoration: none;
  color: black;
}
a:active {
  text-decoration: none;
  color: black;
}
a:link {
  text-decoration: none;
  color: black;
}
a:visited {
  text-decoration: none;
  color: black;
}
a:hover {
  text-decoration: none;
  color: black;
}
.v-toolbar__title {
  overflow: visible !important;
}
.send_button {
  width: 60%;
}
.send_button_container {
  display: flex;
  justify-content: flex-end;
}
.translated {
  transform: translateY(100%);
}
.fullHeightSpacer {
  width: 100%;
  height: 100px;
}
.halfHeightSpacer {
  width: 100%;
  height: 50px;
}
.zeroHeightSpacer {
  width: 100%;
  height: 0px;
}
.logo_container {
  display: flex;
  width: 13.938rem;
}
.logo {
  object-fit: cover;
  width: 100%;
}
</style>
